import { useUserQuery } from '~generated/hooks'
import useCookie from '~hooks/useCookie'
import { AUTH_DATA_KEYS } from '~lib/constants'

export default function useCurrentUser() {
  const cookie = useCookie()
  const { data: { user } = {} } = useUserQuery({
    returnPartialData: true,
    variables: { id: cookie[AUTH_DATA_KEYS.USER_ID] },
  })

  return user
}
